var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticlesHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "articles",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.007,
    height: 58.88,
    viewBox: "0 0 46.007 58.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4513"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M943.611-499.311v-4.313l-7.109,7.348h4.073A3.036,3.036,0,0,0,943.611-499.311Z",
    transform: "translate(-935.688 504.485)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M977.4-504.529H945.61v6.045a4.254,4.254,0,0,1-4.254,4.253h-5.709V-449.9a4.254,4.254,0,0,0,4.254,4.254h37.5a4.254,4.254,0,0,0,4.254-4.254v-50.373A4.254,4.254,0,0,0,977.4-504.529Zm-28.545,46.663h-6.492a.951.951,0,0,1-.951-.951.951.951,0,0,1,.951-.951h6.492a.951.951,0,0,1,.951.951A.951.951,0,0,1,948.855-457.866Zm0-11.327h-6.492a.951.951,0,0,1-.951-.951.951.951,0,0,1,.951-.952h6.492a.951.951,0,0,1,.951.952A.951.951,0,0,1,948.855-469.192Zm0-11.326h-6.492a.951.951,0,0,1-.951-.951.951.951,0,0,1,.951-.951h6.492a.951.951,0,0,1,.951.951A.951.951,0,0,1,948.855-480.518Zm26.082,22.652H955.8a.952.952,0,0,1-.951-.951.952.952,0,0,1,.951-.951h19.142a.951.951,0,0,1,.952.951A.951.951,0,0,1,974.938-457.866Zm0-11.327H955.8a.951.951,0,0,1-.951-.951.952.952,0,0,1,.951-.952h19.142a.951.951,0,0,1,.952.952A.951.951,0,0,1,974.938-469.192Zm0-11.326H955.8a.952.952,0,0,1-.951-.951.952.952,0,0,1,.951-.951h19.142a.951.951,0,0,1,.952.951A.951.951,0,0,1,974.938-480.518Z",
    transform: "translate(-935.647 504.529)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesHome);
export default __webpack_public_path__ + "static/media/articlesHome.5a724c7e39474e87b46db82370767057.svg";
export { ForwardRef as ReactComponent };